<template>
    <div class="mediver-register-container">
        <div class="register-logo-box">
            <h2 class="main-title">Electroceuticals</h2>
            <div class="sub-title">회원가입</div>
            <!-- <img src="@/assets/resource/icon/logo.svg" alt="Electroceuticals" class="register-logo" /> -->
        </div>
        <form class="register-box" @submit.prevent="submit">
            <div class="register-row">
                <label class="register-label" for="name">이름</label>
                <input id="name" class="register-input" v-model="name" placeholder="이름 (실명)" autocomplete="name" />
            </div>
            <div class="register-row">
                <label class="register-label" for="userid">아이디</label>
                <input id="name" class="register-input" v-model="userid" placeholder="아이디" autocomplete="name" @input="onIdChange"/>
                <button type="button" class="dup-check-btn" @click="dupCheckID">중복확인</button>
            </div>
            <div class="register-row">
                <label class="register-label" for="email">이메일</label>
                <input id="email" class="register-input" v-model="email" placeholder="이메일" autocomplete="username" @input="onEmailChange"/>
                <button type="button" class="dup-check-btn" @click="dupCheckEmail">중복확인</button>
            </div>
            <div class="register-row">
                <label class="register-label" for="password">비밀번호</label>
                <input id="password" type="password" class="register-input" v-model="password" placeholder="비밀번호" autocomplete="new-password" />
            </div>
            <div class="register-row">
                <label class="register-label" for="passwordCheck">비밀번호 확인</label>
                <input id="passwordCheck" type="password" class="register-input" v-model="passwordCheck" placeholder="비밀번호 재입력" autocomplete="new-password" />
            </div>
            <div class="register-row">
                <label class="register-label" for="phone">전화번호</label>
                <input id="phone" class="register-input" v-model="phone" placeholder="휴대폰 번호" autocomplete="tel" />
            </div>
            <div class="register-row">
                <label class="register-label" for="level">권한</label>
                <select id="level" class="register-select" v-model="level">
                    <option value="">선택</option>
                    <option value="0">사용자</option>
                    <option value="1">관리자</option>
                </select>
            </div>
            <div class="register-row">
                <label class="register-label" for="hospital">병원명</label>
                <select id="hospital" class="register-select" v-model="hospital">
                    <option value="">선택</option>
                    <option value="0">서울대학교병원</option>
                    <option value="1">강남세브란스</option>
                    <option value="2">삼성서울병원</option>
                </select>
            </div>
            <div class="register-row">
                <label class="register-label" for="dept">부서</label>
                <select id="dept" class="register-select" v-model="dept">
                    <option value="">선택</option>
                    <option value="0">진료과</option>
                    <option value="1">의무지원과</option>
                    <option value="2">행정과</option>

                </select>
            </div>
            <div class="register-row">
                <label class="register-label" for="position">직책</label>
                <select id="position" class="register-select" v-model="position">
                    <option value="">선택</option>
                    <option value="0">과장</option>
                    <option value="1">팀장</option>
                    <option value="2">사원</option>
                </select>
            </div>
            <div class="register-row">
                <label class="register-label" for="role">담당 업무</label>
                <select id="role" class="register-select" v-model="role">
                    <option value="">선택</option>
                    <option value="0">진단 전담</option>
                    <option value="1">처방 전담</option>
                    <option value="2">겸임</option>
                    <option value="3">시스템 관리자</option>
                </select>
            </div>
            <button type="submit" class="register-btn">회원가입</button>
            <div class="register-note">가입 후 관리자 승인 절차가 있습니다.</div>
            <div class="register-links">
                <span class="link" @click="$emit('toLogin')">로그인 화면</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toResetPassword')">비밀번호 찾기</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toFindId')">아이디 찾기</span>
            </div>
        </form>
    </div>
</template>

<script>
import api, {urls} from '@/api'

export default {
    name: 'Register',
    data() {
        return {
            name: '테스트',
            email: 'admin1@osangtech.co.kr',
            userid: 'admin1',
            password: '1111',
            passwordCheck: '1111',
            phone: '01012341234',
            hospital: '',
            dept: '',
            position: '',
            role: '',
            level:'',
            isEmailChecked: false,  // 중복확인 완료 플래그 추가
            isIdChecked: false,  // 중복확인 완료 플래그 추가
        };
    },
    methods: {
        onEmailChange() {
            // 이메일 변경 시 중복확인 플래그 초기화
            this.isEmailChecked = false;
        },
        onIdChange() {
            // 이메일 변경 시 중복확인 플래그 초기화
            this.isIdChecked = false;
        },

        dupCheckEmail() {
            if (!this.email) {
                alert("이메일을 입력해주세요.");
                return;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.email)) {
                alert("올바른 이메일 형식을 입력해주세요.");
                return;
            }

            api.post(urls.login.checkEmail, { email: this.email })
                .then(response =>{
                    if (response.data  === 0) {
                        alert("이미 사용 중인 이메일입니다. 다른 이메일을 입력해주세요.");
                        this.isEmailChecked = false;
                    } else {
                        alert("사용 가능한 이메일입니다.");
                        this.isEmailChecked = true;
                    }
                })
                .catch(e => {
                    alert("이메일 중복 확인 중 오류가 발생했습니다.");
                    console.error(e);
                    this.isEmailChecked = false;
                })
        },
        async dupCheckID() {
            if (!this.userid) {
                alert("아이디을 입력해주세요.");
                return;
            }
            api.post(urls.login.checkID, { userid: this.userid })
                .then(response =>{
                    if (response.data  === 0) {
                        alert("이미 사용 중인 아이디입니다. 다른 아이디을 입력해주세요.");
                        this.isIdChecked = false;
                    } else {
                        alert("사용 가능한 아이디입니다.");
                        this.isIdChecked = true;
                    }
                })
                .catch(e => {
                    alert("아이디 중복 확인 중 오류가 발생했습니다.");
                    console.error(e);
                    this.isIdChecked = false;
                })

        },

        async submit() {
            // 입력값 유효성 검사
            if (!this.name) {
                alert("이름을 입력해주세요.");
                return;
            }
            if (!this.userid) {
                alert("아이디을 입력해주세요.");
                return;
            }
            if (!this.isIdChecked) {
                alert("아이디 중복확인을 해주세요.");
                return;
            }
            if (!this.email) {
                alert("이메일을 입력해주세요.");
                return;
            }
            if (!this.isEmailChecked) {
                alert("이메일 중복확인을 해주세요.");
                return;
            }
            if (!this.password) {
                alert("비밀번호를 입력해주세요.");
                return;
            }
            if (!this.passwordCheck) {
                alert("비밀번호 확인을 입력해주세요.");
                return;
            }
            if (this.password !== this.passwordCheck) {
                alert("비밀번호가 일치하지 않습니다.");
                return;
            }
            if (!this.phone) {
                alert("전화번호를 입력해주세요.");
                return;
            }
            if (!this.level) {
                alert("권한을 선택해주세요.");
                return;
            }
            if (!this.hospital) {
                alert("병원명을 선택해주세요.");
                return;
            }
            if (!this.dept) {
                alert("부서를 선택해주세요.");
                return;
            }
            if (!this.position) {
                alert("직책을 선택해주세요.");
                return;
            }
            if (!this.role) {
                alert("담당업무를 선택해주세요.");
                return;
            }

            api.post(urls.login.register, {
                    name: this.name,
                    id: this.userid,
                    email: this.email,
                    password: this.password,
                    phone: this.phone,
                    role:this.role,
                    hospital: this.hospital,
                    dept: this.dept,
                    position: this.position,
                    level:this.level,
                })
                .then(response =>{
                    const result = response.data;
                    if (result === 1) {
                        this.error = '';
                        alert("회원가입 완료 되었습니다. 승인후 이용바랍니다.");
                        this.$router.push('/'); // 성공시 메인으로 이동
                    } else {
                        this.error = result.message || '회원가입에 실패하였습니다.';
                        alert(this.error);
                    }
                })
                .catch(e => {
                    this.error = '회원가입 중 오류가 발생했습니다.';
                    alert(this.error);
                    console.error(e);
                })
        },


    }
};
</script>
